import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormService } from '../services/form.service';

@Pipe({
  name: 'fieldInvalid',
  pure: false,
  standalone: false,
})
export class FieldInvalidPipe implements PipeTransform {
  public constructor(private formService: FormService) {}

  /**
   * Returns true if the field is invalid and should show aria-invalid
   */
  public transform(value: UntypedFormGroup, field: string): boolean {
    return !this.formService.isFieldValid(field, value);
  }
}
